import React from "react";

export default function TeamLogo({ id, imageUrl }) {
    return (
        <div className="team-img">
            {id === 0 ? (
                <></>
            ) : (
                <a href={"/missions/modify-team-photo/" + id}
                    rel="tooltip"
                    title="Modify photo"
                >
                    {imageUrl && <img src={imageUrl} alt="" />}
                </a>
            )}
            
        </div>
    );
}
